<template>
  <v-dialog v-model="showDialog" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        outlined
        color="primary"
        class="ml-3"
      >
        NOVO EVENTO
      </v-btn>
    </template>
    <v-card>
      <v-card-title
        class="modal-header elevation-10"
      >
        <v-row>
          <v-col>
            <slot name="title">Cadastro de Encontro</slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="showDialog = false" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="6">
            <app-group-solution-combobox
              :filter="payload"
              @onChange="getMembers"
              :name="isAT ? 'Grupo/Tema' : 'Grupo'"
            >
            </app-group-solution-combobox>
          </v-col>
        </v-row>

        <v-row v-if="estado !== 'SC'">
          <v-col sm="6">
            <v-text-field
              label="Nome do encontro"
              v-model="payload.nome"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              v-model="payload.inicioString"
              v-mask="'##/##/#### ##:##'"
              label="Data de Início"
              placeholder="00/00/0000 00:00"
              @blur="repeatedMeetings()"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
              v-model="payload.duracaoString"
              v-mask="'##:##'"
              label="Duração do Evento"
              placeholder="00:00"
              @blur="setFimString()"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
              v-model="payload.fimString"
              v-mask="'##/##/#### ##:##'"
              label="Data de Término"
              placeholder="00/00/0000 00:00"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row
          v-if="payload.solucoesEvento.length > 0"
        >
          <v-col
            md="9"
            sm="9"
            lg="9"
          >
            <v-text-field
              label="Solução do encontro"
              v-model="payload.solucoesEvento[0].nome"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row
          v-if="payload.solucoesEvento.length > 0 && payload.solucoesEvento[0].monitoramento === 2"
        >
          <v-col
            md="3"
            sm="3"
            lg="3"
          >
            <v-radio-group
              v-model="payload.solucoesEvento[0].tipoMonitoramentoEvento"
            >
              <v-radio
                label="Trabalho de Escritório"
                value=1
              ></v-radio>
              <v-radio
                label="Visita"
                value=2
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row
          v-if="payload.solucoesEvento.length > 0"
        >
          <v-col
            md="9"
            sm="9"
            lg="9"
          >
            <v-combobox
              v-model="payload.tarefasEvento"
              :items="tarefas"
              chips
              clearable
              label="Tarefas"
              item-text="nome"
              item-value="municipioTarefaId"
              multiple
              :menu-props="{ auto: true }"
            >
              <template v-slot:selection="{ attrs, item }">
                <v-chip
                  close
                  @click:close="removeTarefa(item)"
                >
                  <strong>{{ item.nome }}</strong>
                </v-chip>
              </template>
            </v-combobox>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            md="9"
            sm="9"
            lg="9"
          >
            <v-select
              v-model="payload.convidadosEvento"
              :items="membros"
              chips
              label="Membros"
              item-text="nome"
              multiple
              :return-object="true"
            >
              <template slot="no-data">
                Nenhum membro retornado
              </template>
            </v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <app-modal-insert-member
              :edit="false"
              :color="'success'"
              :icon="'mdi-plus-circle'"
              :municipioId="payload.municipioId"
              @onSave="getMembers"
            >
              <template v-slot:title
                :edit="false"
              >
                Cadastrar Membro
              </template>
            </app-modal-insert-member>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              label="Observações"
              v-model="payload.observacoes"
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row v-if="repeatedInvite">
          <v-col>
            <v-alert
              border="top"
              color="red lighten-2"
              dark
            >
              Já existe outro evento para o mesmo membro na mesma data
            </v-alert>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="showDialog = false">Fechar</v-btn>
        <v-btn color="info" outlined text @click="save()">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { cityAPI, AppGroupSolutionCombobox } from '@/modules/city'
import { meetingAPI } from '@/modules/calendar'
import { memberAPI } from '@/modules/city/components/MemberAPI'
import { cityTaskAPI } from '@/modules/city/API/CityTaskAPI'
import { mapActions, mapGetters } from 'vuex'
import AppModalInsertMember from '@/modules/city/components/group/ModalInsertMember'
import moment from 'moment'

export default {
  name: 'AppModalInsertMeeting',
  props: {
    dialog: { type: Boolean, default: false },
    meetings: { type: Array }
  },
  components: {
    AppGroupSolutionCombobox,
    AppModalInsertMember
  },
  data () {
    return {
      payload: {
        nome: null,
        grupoId: 0,
        municipioId: this.$route.params.id,
        solucoesEvento: [],
        tarefasEvento: [],
        convidadosEvento: [],
        observacoes: null
      },
      menu: '',
      menu2: '',
      date: null,
      time: null,
      eixos: [],
      tarefas: [],
      membros: [],
      showDialog: this.dialog,
      municipio: {},
      estado: this.$store.state.uf,
      repeatedInvite: false
    }
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    getTasks () {
      this.setLoading(true)
      cityTaskAPI.getTasks(this.payload.solucoesEvento.map(function (item) { return item.municipioSolucaoId }))
        .then(resp => {
          this.tarefas = resp.data.filter(response => {
            return !response.desabilitado
          // this.tarefas = resp.data
          })
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao obter tarefas')
        })
    },
    getMembers () {
      this.setLoading(true)
      memberAPI.getMembersByCity(this.payload.municipioId)
        .then(resp => {
          this.membros = resp.data
          this.removeSolucao()
          this.getMembersByGroup()
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao obter membros')
        })
    },
    getMembersByGroup () {
      memberAPI.getMembers(this.payload.grupo.grupoId)
        .then(resp => {
          this.payload.convidadosEvento = resp.data
          this.payload.grupoId = this.payload.grupo.grupoId
          this.getName()
          if (this.payload.solucoesEvento[0] !== undefined) {
            this.getTasks()
          }
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao obter membros')
        })
    },
    getName () {
      meetingAPI.getName(this.payload)
        .then(resp => {
          this.payload.nome = resp.data
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao obter Nome do Evento')
        })
    },
    removeSolucao () {
      if (this.payload.solucoesEvento.length > 0) {
        this.payload.solucoesEvento.splice(this.payload.solucoesEvento.indexOf(this.payload.grupo.municipioSolucao), 1)
      }
      this.payload.solucoesEvento = [...this.payload.solucoesEvento]
      this.tarefas = []
      this.chipsTarefas = []
      if (this.payload.grupo.municipioSolucao) {
        this.payload.solucoesEvento.push(this.payload.grupo.municipioSolucao)
      }
      this.removeTarefa()
    },
    removeTarefa (item) {
      if (this.payload.tarefasEvento.length > 0) {
        this.payload.tarefasEvento.splice(this.payload.tarefasEvento.indexOf(item), 1)
      } else {
        this.payload.tarefasEvento = []
      }
      this.payload.tarefasEvento = [...this.payload.tarefasEvento]
    },
    removeMembro (item) {
      this.payload.convidadosEvento.splice(this.payload.convidadosEvento.indexOf(item), 1)
      this.payload.convidadosEvento = [...this.payload.convidadosEvento]
    },
    save () {
      if (!this.payload.inicioString || this.payload.inicioString.length < 16) {
        this.$notification.error('É obrigatório o preenchimento de data e hora de início do evento')
      } else if (!this.payload.fimString || this.payload.fimString.length < 16) {
        this.$notification.error('É obrigatório o preenchimento de data e hora de término do evento')
      } else if (this.repeatedMeetings() && !this.repeatedInvite) {
        this.$notification.error('Já existe outro evento do mesmo grupo na mesma data')
      } else {
        this.setLoading(true)
        meetingAPI.create(this.payload)
          .then(resp => {
            this.$emit('onSave')
            this.showDialog = false
            this.payload.nome = null
            this.payload.grupoId = 0
            this.payload.inicioString = null
            this.payload.duracaoString = null
            this.payload.fimString = null
            this.payload.municipioId = this.$route.params.id
            this.payload.grupo = []
            this.payload.solucoesEvento = []
            this.payload.tarefasEvento = []
            this.payload.convidadosEvento = []
            this.payload.observacoes = null
            this.tarefasEvento = []
            this.membros = []
          })
          .catch(resp => {
            this.setLoading(false)
            this.$notification.error('Erro ao cadastrar encontro')
          })
      }
    },
    loadCity () {
      this.setLoading(true)
      cityAPI.get(this.$route.params.id)
        .then(resp => {
          this.municipio = resp.data
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao obter município')
        })
    },
    repeatedMeetings () {
      let repeated = false

      this.meetings.forEach(meeting => {
        if (this.payload.grupoId === meeting.grupoId && this.payload.inicioString === meeting.inicioString) {
          repeated = true

          this.payload.convidadosEvento.forEach(convidadoEvento => {
            if (meeting.convidadosEvento.some(convidado => convidado.membroId === convidadoEvento.membroId)) {
              this.repeatedInvite = true
            }
          })
        }
      })

      return repeated
    },
    setFimString () {
      let inicioDate = moment(this.payload.inicioString, 'DD/MM/YYYY HH:mm').add(this.payload.duracaoString.substring(0, 2), 'hours').format('DD/MM/YYYY HH:mm')
      this.payload.fimString = moment(inicioDate, 'DD/MM/YYYY HH:mm').add(this.payload.duracaoString.substring(3), 'minutes').format('DD/MM/YYYY HH:mm')
      this.$forceUpdate()
      return this.payload.fimString
    }
  },
  computed: {
    ...mapGetters([
      'loading' , 'isAT'
    ])
  },
  created () {
    this.loadCity()
  }
}
</script>
